// @see mylw-preprod.nexcess-internal.workers.dev
import prodTemplate from './prod';
import type { AppConfigI } from './example';

const preprod: AppConfigI = {
	...prodTemplate,
	gaTrackerId: 'G-RWVHZPXV4N',
	gtmContainerId: 'GTM-PQFRHRZH',
	openId: {
		client_id: 'mylw-preprod-cp',
		authority: 'https://login.liquidweb.com',
		accessTokenExpiringNotificationTime: 1200,
	},
};

export default preprod;
